/* eslint-disable max-lines-per-function */
import React, { FC } from 'react';
import { withTranslation } from 'react-i18next';
import { AdvancedOptions } from '@dev/ee-api/ee-api-models';
import { TrackingAndPruning as Screen } from '@dev/ee-modules';
import { connect } from 'react-redux';
import { compose } from 'react-recompose';
import { push as Push } from 'redux-first-history';
import { ApplicationState as State } from '@/store';
import { AccountStartUpdate, ValidateInput } from '@/store/account/actions';
import { SettingsPaths } from '@/services/dictionaries/Paths';
import { links } from '@/services/dictionaries/links';
import { TrackingAndPruningProps as Props } from './TrackingAndPruningInterface';

const mapState = (state: State, ownProps: Props): Props => ({
    account: state.account,
    browser: state.browser,
    ...ownProps,
});
const dispatchProps = {
    AccountStartUpdate,
    Push,
    ValidateInput,
};
interface DispatchProps {
    AccountStartUpdate(option: keyof AdvancedOptions, value: string | boolean | number): any;
    Push(url: string): void;
    ValidateInput(options: Record<string, string>, type: string): void;
}
type ExtendedProps = Props & DispatchProps;

const TrackingAndPruning: FC<ExtendedProps> = (props: ExtendedProps): JSX.Element => (
    <Screen links={links} paths={SettingsPaths} {...props} />
);

export default compose(
    withTranslation('settings'),
    connect<Props, DispatchProps>(mapState, dispatchProps)
)(TrackingAndPruning);
